import ApiService from "@/core/services/api/v2/api.service";

const ADDRESS_TYPE_LIST_KEY = "AddressTypeList";

const AddressTypeService = {
  listAll() {
    return new Promise(resolve => {
      // This list is widely used and changes rarely, so cache its values
      let cachedList = window.sessionStorage.getItem(ADDRESS_TYPE_LIST_KEY);
      if (cachedList) {
        resolve(JSON.parse(cachedList));
      } else {
        ApiService.get("addressType")
          .then(response => {
            let newList = response.data.response.AddressTypes;

            window.sessionStorage.setItem(
              ADDRESS_TYPE_LIST_KEY,
              JSON.stringify(newList)
            );

            resolve(newList);
          })
          .catch(() => {
            resolve([]);
          });
      }
    });
  }
};

export default AddressTypeService;
